import { render, staticRenderFns } from "./G-1-1b-2__SupportEdit_B2B_AfterSalesService.vue?vue&type=template&id=2af24c83&"
import script from "./G-1-1b-2__SupportEdit_B2B_AfterSalesService.vue?vue&type=script&lang=js&"
export * from "./G-1-1b-2__SupportEdit_B2B_AfterSalesService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
